import Cookies from 'js-cookie';

type RemoveCookieProps = { keys: string[] };

/**
 * Removes multiple cookies with the specified keys.
 * @function removeCookieValues
 * @param {RemoveCookieProps} props - An object containing an array of keys for cookies to be removed.
 * Each key represents the cookie name to be removed.
 */
const removeCookieValues = ({ keys }: RemoveCookieProps) => {
  keys.forEach((key) => {
    Cookies.remove(key, {
      domain : '.ingresse.com',
      path : '/',
      secure : true,
      sameSite : 'None'
    });
  });
};

export { removeCookieValues };
